import { NotFound } from "@/pages/errorPages/notFound";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/notfound")({
  component: NotFound,
});
